"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnCanvasResized = void 0;
/**
 * @public
 * Provides events for chart resizing, emitted on {@link IChartComponent.resize} call.
 */
class OnCanvasResized {
    constructor(onCanvasResized) {
        this.onCanvasResized = onCanvasResized;
    }
    static registerListener(eventService, onEvent) {
        return eventService
            .getCategory(OnCanvasResized)
            .addTemporaryListener(new OnCanvasResized(onEvent));
    }
    static emit(eventService, canvasDims) {
        const listeners = eventService
            .getCategory(OnCanvasResized)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onCanvasResized(canvasDims);
        }
    }
}
exports.OnCanvasResized = OnCanvasResized;
OnCanvasResized.callbackKey = "onCanvasResized";
//# sourceMappingURL=on-canvas-resized.js.map